<template>
  <div>
    <div class="personalBox">
      <p class="title">用户账号管理</p>
      <Form ref="searchForm" :label-width="110" :model="formCustom" :rules="addRules" inline>
        <FormItem class="avatarImg" label="头像：">
          <Avatar v-if='this.avatarImg === null || this.avatarImg === "" ' icon="ios-person" size="large"/>
          <Avatar v-else-if='this.avatarImg !== ""' :src='avatarImg' size="large"/>
          <Upload :action="upAction" :format="['jpg','jpeg','png']" :headers="getToken"
                  :max-size="2048" :on-error="handleError" :on-exceeded-size="handleMaxSize"
                  :on-format-error="handleFormatError" :on-success="handleSuccess" :show-upload-list="false"
                  style="display: inline-block;">
            <Button type="primary">上传</Button>
          </Upload>
          <p class="Tips">提示：图片格式仅支持jpg，jpeg，png三种格式，且大小不能超过2M</p>
        </FormItem>
        <br>
        <FormItem label="用户账号姓名：" prop='nikeName'>
          <Input v-model="formCustom.nikeName" clearable placeholder="请输入用户账号姓名" style="width: 240px"></Input>
        </FormItem>
        <br>
        <FormItem label="性别：">
          <Select v-model="formCustom.gender" clearable filterable style="width: 240px">
            <Option value="1">男</Option>
            <Option value="0">女</Option>
          </Select>
        </FormItem>
        <br>
        <FormItem label="手机号：" prop='telephone'>
          <Input v-model="formCustom.telephone" clearable placeholder="请输入手机号" style="width: 240px"></Input>
        </FormItem>
      </Form>
    </div>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="addLoading" style="margin-left: 10px" type="primary" @click="handleCommit('searchForm')">
        <span v-if="!addLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {loginProfile, loginProfileEdit} from '@/api/login.js'

export default {
  name: 'personal',
  inject: ['reload'],
  data() {
    return {
      addLoading: false, // 提交时等待
      adminId: '', // 获取用户id
      formCustom: {
        nikeName: '',
        gender: '',
        telephone: ''
      },
      addRules: {
        nikeName: [{required: true, message: '用户账号姓名不能为空', trigger: 'blur'}],
        telephone: [{required: true, message: '手机号码不能为空', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              let reg = /[\u4E00-\u9FFF]+/g
              if (!reg.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确手机号码，不能包含中文。'))
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              let telNum = /^1\d{10}$/
              if (telNum.test(value)) {
                callback()
              } else {
                callback(new Error('请输入正确手机号码，共11位'))
              }
            },
            trigger: 'blur'
          }
        ]
      },
      upAction: this.$getImg + 'api/auth/img', // 上传图片网址
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
      avatarImg: '' // 头像图片
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      loginProfile().then(res => {
        localStorage.setItem('peopleName', res.data.data.nikeName)
        localStorage.setItem('peopleTel', res.data.data.telephone)
        localStorage.setItem('peopleOrgid', res.data.data.orgId)
        this.adminId = res.data.data.adminId
        this.formCustom = res.data.data
        this.formCustom.gender = res.data.data.gender.toString()
        this.avatarImg = res.data.data.imgPath
      })
    },
    // 上传图片成功
    handleSuccess(response) {
      this.avatarImg = this.$getImgUrl + response.data
    },
    // 上传图片失败
    handleError(error, file) {
      this.$Message.error(file.msg)
    },
    // 超出限制大小
    handleMaxSize() {
      this.$Message.error('所传图片不能超过2M,请重新选择')
    },
    // 验证失败钩子
    handleFormatError() {
      this.$Message.error('请上传正确的图片格式，仅支持jpg，jpeg，png三种格式')
    },
    // 返回
    handleBack() {
      this.$router.go(-1)
    },
    // 提交
    handleCommit(name) {
      this.addLoading = true
      if (this.formCustom.gender === null) {
        this.formCustom.gender = ''
      }
      this.$refs[name].validate((valid) => {
        if (valid) {
          loginProfileEdit({
            // adminId: this.adminId,
            nikeName: this.formCustom.nikeName,
            gender: this.formCustom.gender,
            telephone: this.formCustom.telephone,
            imgPath: this.avatarImg
          }).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false

              this.reload()
              this.init()
              if (this.$route.params.source == 'addEnterprise') {
                this.$router.push({
                  name: 'addEnterprise', params: {
                    source: 'personal',
                    type: this.$route.params.type
                  }
                })
              }
            }
          }).catch(() => {
            this.addLoading = false
          })
        } else {
          this.addLoading = false
        }
      })
    }
  }
}
</script>

<style lang='less' scoped>
.personalBox {
  padding-bottom: 20px;
  border: 0.0625rem solid #f2f2f2;
  background-color: #ffffff;

  .avatarImg {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 0;

    /deep/ .ivu-form-item-content {
      margin-left: 0 !important;
    }
  }

  /deep/ .ivu-avatar-large.ivu-avatar-icon {
    font-size: 2.5rem;
  }

  /deep/ .ivu-avatar-large {
    width: 3.5rem;
    height: 3.5rem;
    line-height: 3.5rem;
    margin-left: 40px;
    margin-right: 20px;
  }

  .title {
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    font-weight: bold;
    margin-bottom: 20px;
    border-bottom: 1px solid rgb(205, 205, 205);
  }

  .Tips {
    display: inline-block;
    font-size: 0.8rem;
    color: rgba(128, 122, 122);
    margin-left: 30px;
  }
}
</style>
